import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import { getTrackingAttributes, TRACKING_CATEGORIES } from '../../configuration/setup/googleAnalytics';
import type { Partner } from '../../services/partnerNetwork.types';
import PartnershipStatus from '../../components/PartnershipStatus';
import EditPartnerDialog from '../editPartnerDialog/EditPartnerDialog';
import ConnectionTypeLabel from '../../components/ConnectionTypeLabel';

type PartnerSummaryProps = {
    partner: Partner;
};

const PartnerSummary = ({ partner }: PartnerSummaryProps) => {
    const [isEditDialogShown, showEditDialog] = useState(false);
    const partnerIsDeleted = partner.status === 'rescinded';

    return (
        <>
            <div
                className='display-flex align-items-start margin-bottom-15'
                {...getTrackingAttributes({
                    trigger: 'visibility',
                    category: TRACKING_CATEGORIES.OVERVIEW,
                    action: 'Sidebar shown',
                    label: 'Sidebar shown',
                })}
            >
                <div className='margin-right-15 bg-lightest rounded-circle padding-25 display-grid place-items-center text-size-16'>
                    <span className='uikit-icon icon-user text-color-dark text-size-200pct' />
                </div>
                <div className='flex-1-1 display-flex flex-column gap-10 position-relative'>
                    <div className='flex-1-1'>
                        <label className='margin-bottom-0'>
                            <FormattedMessage id='intl-msg:network.label.companyName' />
                        </label>
                        <div className='margin-bottom-5'>
                            <div>{partner?.name}</div>
                        </div>
                    </div>
                    <div className='flex-1-1'>
                        <label className='margin-bottom-0'>Verbindung</label>
                        <div>
                            <ConnectionTypeLabel connectionType={partner.connectionType} />
                            <PartnershipStatus partner={partner} />
                        </div>
                    </div>
                    <div className='flex-1-1'>
                        <div className='flex-1-1'>
                            <label className='margin-bottom-0'>
                                <FormattedMessage id='intl-msg:network.label.description' />
                            </label>
                            <div className='margin-bottom-5'>{partner?.description ? partner.description : '-'}</div>
                        </div>
                    </div>

                    {!partnerIsDeleted && (
                        <div className='position-absolute right-0 top-0'>
                            <Button
                                bsStyle='muted-filled'
                                iconName='pencil'
                                iconOnly
                                onClick={() => showEditDialog(true)}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isEditDialogShown && (
                <EditPartnerDialog partner={partner} onClose={() => showEditDialog(false)} show={isEditDialogShown} />
            )}
        </>
    );
};

export default PartnerSummary;
